let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gR3Ts")).then(() => parcelRequire('iYI0U'));